import Vue from 'vue'
import VueRouter from 'vue-router'
// import { menuListRouter } from "./menuRouter";
Vue.use(VueRouter);
// let baseRouter = window.isQiankun ? `/home/${window.webConfig.microName}` : '';
// console.log(baseRouter, 'baseRouter')
let routes = [
    //   {
    //     path:baseRouter+ '',
    //       redirect:{name:window.webConfig.firstPage}
    //   },  {
    //         path: baseRouter + '/index',
    //         name: 'index',
    //         component: () => import(/* webpackChunkName: "about" */ '../views/home/index.vue')
    //     },{
    //         path: baseRouter + '/login',
    //         name: 'login',
    //         component: () => import(/* webpackChunkName: "about" */ '../views/login/index.vue')
    //     },
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "about" */ '../views/home/index.vue')
    },
    {
        path: '/list',
        name: 'list',
        component: () => import(/* webpackChunkName: "about" */ '../views/home/list.vue')
    },
    {
        path: '/detail',
        name: 'detail',
        component: () => import(/* webpackChunkName: "about" */ '../views/home/detail.vue')
    },
];


// function getRouter(arr) {
//     arr.forEach(i=>{
//         if (i.type === 'page' || i.type === 'noMenuPage' ){
//             routes.push({
//                 path: baseRouter + '/' + i.name,
//                 name:i.name,
//                 component:i.component,
//                 meta:{
//                     routerName:i.label,
//                     noLogin:!!i.noLogin
//                 }
//             })
//         }else if (i.children && i.children.length > 0){
//             getRouter(i.children)
//         }
//     })
// }
// getRouter(menuListRouter);

export default new VueRouter({
    routes,
});
